import * as React from 'react';
import TrashCanOutlined from './trash-can-outlined';
import TrashCanFilled from './trash-can-filled';
import type { IconCombinedProps } from './types';
const TrashCanCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <TrashCanFilled ref={ref} {...rest} />;
  }
  return <TrashCanOutlined ref={ref} {...rest} />;
});
export default TrashCanCombined;